
import { Component, Vue } from "vue-property-decorator";
import { accountApi } from "../../services/api/account/account";
import AnonymousLayout from "../../layouts/AnonymousLayout.vue";
import {
  ForgotPasswordConfirmationCommand,
  IForgotPasswordConfirmationCommand,
} from "../../services/api/models/ForgotPasswordConfirmationCommand.model";

@Component({
  components: { AnonymousLayout },
})
export default class ForgotPasswordConfirmation extends Vue {
  private isErrorMessageShow = false;
  private errorMessage = "";
  private password = "";
  private repeatPassword = "";
  private isLoading = false;
  private showPassword = false;
  $router: any;
  $route: any;

  get disabledForm(): boolean {
    return (
      this.password === "" ||
      this.repeatPassword === "" ||
      this.password !== this.repeatPassword
    );
  }

  async submit(e: any) {
    this.isLoading = true;
    e.preventDefault();

    const userId = this.$route.query.userId as string;
    const code = this.$route.query.code as string;
    const data = new ForgotPasswordConfirmationCommand(
      code,
      userId,
      this.password,
      this.repeatPassword
    );

    try {
      await accountApi.forgotPasswordConfirmation(data);
      await this.$router.push({ name: "Login" });
    } catch (err) {
      window.console.log(err.response);
      const errorMessages =
        err?.response?.data !== undefined
          ? this.errorMessages(err.response.data)
          : [];

      if (errorMessages.length > 0) {
        window.console.log(errorMessages);
        let message = "Corrija los siguientes errores: <ul>";
        errorMessages.forEach((m) => (message += `<li>${m}</li>`));
        message += "</ul>";
        this.showError(message);
      } else if (err.response.status === 400 && err.response.data) {
        this.showError(err.response.data);
      } else {
        this.showError("Ha habido algún error. Intentelo de nuevo más tarde.");
      }
    }

    this.isLoading = false;
  }

  showError(error: string) {
    this.errorMessage = error;
    this.isErrorMessageShow = true;
    setTimeout(() => (this.isErrorMessageShow = false), 8000);
  }

  errorMessages(data: any): Array<string> {
    let result = new Array<string>();
    if (data["Password"] !== undefined) {
      const passErrors = data["Password"];
      for (let i = 0; i < passErrors.length; ++i) {
        const passError = passErrors[i];
        if (passError["errorCode"] === "not_contains_number") {
          result.push("La contraseña debe tener algún caracter numérico.");
        } else if (passError["errorCode"] === "short_password") {
          result.push("La contraseña debe tener como mínimo 6 carácteres.");
        } else if (passError["errorCode"] === "not_contains_uppercase") {
          result.push("La contraseña debe tener algúna letra mayúscula.");
        } else if (passError["errorCode"] === "not_contains_lowercase") {
          result.push("La contraseña debe tener algúna letra minúscula.");
        } else if (passError["errorCode"] === "invalid_birthdate") {
          result.push("Fecha no valida.");
        }
      }
    }

    return result;
  }
}
